import React from 'react';
import randomstring from 'uuid/v4';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import Attach from '@material-ui/icons/AttachFile';

import { CircularProgressbar } from "react-circular-progressbar";

import PeriodLabel from './PeriodLabel';


const flatNodes = (node, add) => {
    node.path = `${add}${node.nombre}`;
    let result = [node];
    if (node.hijos) {
        node.hijos.forEach((c) => (result = result.concat(flatNodes(c , add + ' '))));
    }
    return result;
};

class BubbleChart extends React.Component {

    state = {
        titulo: undefined,
        widget: undefined
    }


    static getDerivedStateFromProps(props, state) {
        const { widget } = props;
        if (widget !== state.widget) {
            state.widget = widget;
            state.jerarquia = widget && widget.jerarquia && widget.jerarquia.length > 0 ? flatNodes(widget.jerarquia[0], '') : [];
            state.node = widget && widget.jerarquia && widget.jerarquia.length > 0 ? widget.jerarquia[0].id : undefined;
            state.sets = widget && widget.sets && Object.keys(widget.sets).map((i) => { return {id: i, nombre: widget.sets[i]}; });
            state.set = state.sets && state.sets.length > 0 ? state.sets[0].id : undefined;
            state.serie = state.node && state.set ? widget.series[`${state.set}_${state.node}`] : undefined;
            state.showValue = state.serie && !state.serie.total ? true : false ;
            return state;
        }
        return null;
    }

    handleChange = (event) => {

        
        const { widget } = this.state;
        let estado = this.state;
        estado[event.target.name] = event.target.value;
        const serie = estado.set ? widget.series[estado.set && estado.node ? `${estado.set}_${estado.node}` : `${estado.set}`] : undefined;
        const showValue = serie && !serie.total ? true : false ;
        this.setState({ 
                        [event.target.nombre]: event.target.value,
                        serie: serie,
                        showValue: showValue
                      });
    };

    render() {
        const {intl} = this.props;
        const { widget, serie,  showValue, sets, jerarquia, node, set } = this.state;
        return (<div className="flex_full_column center padding_12">
                    <div className="flex_auto_row width100">
                        <Attach className={'attachIcon'} onClick={this.props.onDownload(this.props.data)} />
                        <span className="flex_full_row center barlowcondensed_medium c_lipstick uppercase">
                            {widget.nombre}
                        </span>
                        <PeriodLabel {...this.props} />
                    </div>
                    <div className=" margin_top_24 flex_full_row center">
                    {serie &&
                        serie.valores &&
                        serie.valores.length > 0 &&
                                    serie.valores.map((v) => {
                                        const percentage = showValue ? 100 : Math.round(((v.y) / serie.total) * 100);
                                        const text = showValue ? `${v.y} ` : `${percentage}%`;
                                        const percentageRef = serie.totalRef ? 100 : Math.round(((v.ref) / serie.totalRef) * 100);
                                        const textRef = (serie.totalRef ? v.ref : `${percentageRef}%`) + ' ref';
                                        return (<div key={randomstring()} className="flex_auto_column center margin_right_2 margin_left_2">
                                                    <div className="flex_full_row">
                                                        <CircularProgressbar value={percentage} text={text} />
                                                    </div>
                                                    {(v.ref || v.ref === 0) &&
                                                        <div className="flex_auto_row barlowsemicondensed_medium c_slate margin_top_8">
                                                            {textRef}
                                                        </div>       
                                                    }
                                                    <div className="flex_auto_row barlow_italic_small c_bluish margin_top_8">
                                                        {v.x}
                                                    </div>        
                                                </div>
                                                );
                                    })
                            
                    }
                    </div>
                   
                    <div className="margin_top_24 flex_auto_row width100" >
                        <FormControl className={'flex_full width100 barlow_italic_medium c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'widget_title_series' })}
                            </InputLabel>
                            <Select
                                native
                                value={set}
                                fullWidth
                                className="barlow_italic_medium"
                                onChange={this.handleChange}
                                inputProps={{ name: 'set', id: 'set' }}
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {sets &&
                                        sets.length > 0 &&
                                        sets.map((s) => {
                                            return (
                                                <option key={randomstring()} value={s.id}>
                                                    {s.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="margin_top_8 flex_auto_row width100" >
                        <FormControl className={'flex_full width100 barlow_italic_medium c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'process_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={node}
                                fullWidth
                                className="barlow_italic_medium"
                                onChange={this.handleChange}
                                inputProps={{ name: 'node', id: 'node' }}
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {jerarquia &&
                                        jerarquia.length > 0 &&
                                        jerarquia.map((s) => {
                                            return (
                                                <option key={randomstring()} value={s.id}>
                                                    {s.path}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>

                </div>

            );
    }
}


export default BubbleChart;


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/types/BubbleChart.js